import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable} from 'rxjs';
import {AppState} from '../store';
import {select, Store} from '@ngrx/store';
import {selectUser} from '../store/selectors';
import {User} from '../models/user.model';


@Injectable()
export class TestUserInterceptor  implements HttpInterceptor {

  user:User;

  hostName:string;

  constructor(private store:Store<AppState>) {

    store
      .pipe(
        select(selectUser)
      )
      .subscribe(user => this.user = user);

    this.hostName =  document.location.hostname;

  }

  intercept(req: HttpRequest<any>,
            next: HttpHandler): Observable<HttpEvent<any>> {

    const isGcsSignedUrl = req.url.startsWith('https://storage.googleapis.com/') || req.url.includes('.firebasestorage.app');

    if (this.user && !isGcsSignedUrl && (req.method == 'POST' || req.method == "PUT" || req.method == "DELETE") ) {
      const cloned = req.clone({
        body: {
          ...req.body,
          testUser: !!this.user.testUser,
          hostName: this.hostName ?? ''
        }
      });
      return next.handle(cloned);
    }
    else {
      return next.handle(req);
    }

  }

}
